import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';


const UserDetailModal = ({ user, onClose, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState(user);

  const roleOptions = [
    { value: 'Provider', label: 'Provider' },
    { value: 'Practice Marketer', label: 'Practice Marketer' },
    { value: 'Administrator', label: 'Administrator' }
  ];

  const statusOptions = [
    { value: 'Active', label: 'Active' },
    { value: 'Pending', label: 'Pending' },
    { value: 'Suspended', label: 'Suspended' }
  ];

  const handleSave = () => {
    onUpdate(formData);
    setIsEditing(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-lg shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto m-4">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-border sticky top-0 bg-card">
          <h2 className="text-xl font-semibold text-foreground">User Details</h2>
          <Button variant="ghost" size="sm" onClick={onClose} iconName="X" />
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* User Avatar and Basic Info */}
          <div className="flex items-center gap-4">
            <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
              <span className="text-3xl font-bold text-primary">{user?.name?.charAt(0)}</span>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-foreground">{user?.name}</h3>
              <p className="text-sm text-muted-foreground">{user?.email}</p>
            </div>
          </div>

          {/* Form Fields */}
          <div className="space-y-4">
            <Input
              label="Full Name"
              value={formData?.name}
              onChange={(e) => setFormData({ ...formData, name: e?.target?.value })}
              disabled={!isEditing}
            />

            <Input
              label="Email Address"
              type="email"
              value={formData?.email}
              onChange={(e) => setFormData({ ...formData, email: e?.target?.value })}
              disabled={!isEditing}
            />

            <Select
              label="Role"
              options={roleOptions}
              value={formData?.role}
              onChange={(value) => setFormData({ ...formData, role: value })}
              disabled={!isEditing}
            />

            <Input
              label="Practice Name"
              value={formData?.practice}
              onChange={(e) => setFormData({ ...formData, practice: e?.target?.value })}
              disabled={!isEditing}
            />

            <Input
              label="Location"
              value={formData?.location}
              onChange={(e) => setFormData({ ...formData, location: e?.target?.value })}
              disabled={!isEditing}
            />

            <Select
              label="Account Status"
              options={statusOptions}
              value={formData?.status}
              onChange={(value) => setFormData({ ...formData, status: value })}
              disabled={!isEditing}
            />
          </div>

          {/* Activity Information */}
          <div className="bg-muted/50 rounded-lg p-4 space-y-2">
            <h4 className="text-sm font-semibold text-foreground mb-3">Activity Information</h4>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <p className="text-muted-foreground">Registration Date</p>
                <p className="text-foreground font-medium">
                  {new Date(user?.registrationDate)?.toLocaleDateString()}
                </p>
              </div>
              <div>
                <p className="text-muted-foreground">Last Login</p>
                <p className="text-foreground font-medium">{user?.lastLogin}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-border bg-muted/30">
          {isEditing ? (
            <>
              <Button variant="outline" onClick={() => setIsEditing(false)}>
                Cancel
              </Button>
              <Button variant="default" onClick={handleSave} iconName="Save" iconPosition="left">
                Save Changes
              </Button>
            </>
          ) : (
            <>
              <Button variant="outline" onClick={onClose}>
                Close
              </Button>
              <Button
                variant="default"
                onClick={() => setIsEditing(true)}
                iconName="Edit"
                iconPosition="left"
              >
                Edit User
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserDetailModal;